<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Blog</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Blog</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Area -->
<section class="blog-area ptb-110">
    <div class="container">
       <div class="row">

            <div
                class="col-lg-4 col-md-6"
                *ngFor="let blog of blogs">

                <div class="single-blog-post">

                    <!-- Image -->
                    <div class="entry-thumbnail">

                        <a [routerLink]="['/blog', blog.id]">

                            <img
                                [src]="blog.image"
                                [alt]="blog.title">

                        </a>

                    </div>


                    <!-- Content -->
                    <div class="entry-post-content">

                        <div class="entry-meta">

                            <ul>

                                <li>
                                    <a href="javascript:void(0)">
                                        {{ blog.category }}
                                    </a>
                                </li>

                                <li>
                                    {{ blog.date }}
                                </li>

                            </ul>

                        </div>


                        <h3>

                            <a [routerLink]="['/blog', blog.id]">
                                {{ blog.title }}
                            </a>

                        </h3>


                        <p>
                            {{ blog.shortDescription }}
                        </p>


                        <a
                            [routerLink]="['/blog', blog.id]"
                            class="read-more-btn">

                            Read More

                            <i class="flaticon-add-1"></i>

                        </a>

                    </div>

                </div>

            </div>

        </div>
    </div>
</section>
<!-- End Blog Area -->
